import SubmitOnPremSiteToSiteVPNConfiguration from "./SubmitOnPremSiteToSiteVPNConfiguration";
import SubmitOnPremSiteToSiteVPNStandardConfiguration from "./SubmitOnPremSiteToSiteVPNStandardConfiguration";

export default class SubmitOnPremSiteToSiteVPNRequest {

	type!: string;

	companyName!: string;

	trackerID!: number;

	workID!: number;

	approver!: number;

	exxonConfiguration!: SubmitOnPremSiteToSiteVPNConfiguration;

	externalConfiguration!: SubmitOnPremSiteToSiteVPNConfiguration;

	standardConfiguration!: SubmitOnPremSiteToSiteVPNStandardConfiguration;

	exxonEncrypDomain!: string;

	externalEncrypDomain!: string;

	conDeviceCount!: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}